export default {
  cssPrefix: 'kz-'
};